import React, {
  createContext,
  useContext,
  useRef,
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { io } from 'socket.io-client';
import { useDispatch } from 'react-redux';
import { addNotification } from 'src/actions/notificationActions';
import { NOTIFICATION_STATUS } from 'src/constants';

export function createNamespaceWebSocketContext(namespace, showError) {
  const NamespaceWebSocketContext = createContext(null);

  function NamespaceWebSocketProvider({
    children,
  }) {
    const [isConnected, setConnected] = useState(false);
    const socket = useRef(null);
    const dispatch = useDispatch();

    const token = localStorage.getItem('accessToken');

    const socketErrorMessage = (message) => {
      if (showError) {
        dispatch(addNotification('SOCKET_ERROR', message, NOTIFICATION_STATUS.ERROR));
      } else {
        console.log(message);
      }
    };

    const handleSocketError = () => {
      socketErrorMessage('Wrong connection. Please reload this page.');
    };

    useEffect(() => {
      if (token && !isConnected) {
        socket.current = io(`${process.env.REACT_APP_API_BASE_URL}${namespace}`, {
          transports: ['websocket', 'webtransport'],
          reconnection: true,
          reconnectionAttempts: 3,
          auth: { token },
        });

        socket.current.on('connect', () => {
          setConnected(true);
        });

        socket.current.on('connect_error', handleSocketError);
        socket.current.on('connect_timeout', handleSocketError);
        socket.current.on('reconnect_error', handleSocketError);
      }

      return () => {
        if (socket.current) {
          socket.current.close();
          setConnected(false);
        }
      };
    }, [token]);

    return (
      <NamespaceWebSocketContext.Provider value={socket.current}>
        {children}
      </NamespaceWebSocketContext.Provider>
    );
  }

  NamespaceWebSocketProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const useNamespaceWebSocket = () => useContext(NamespaceWebSocketContext);

  return {
    NamespaceWebSocketProvider,
    useNamespaceWebSocket,
  };
}
